// extracted by mini-css-extract-plugin
export default {"home":"styles_home__VTUDc","versionInfo":"styles_versionInfo__ElLLU","checkboxGroup":"styles_checkboxGroup__TpQcD","privacyTypeRadio":"styles_privacyTypeRadio__yseT9"};